var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.parcel.freeSmallWeightAddrMap[_vm.jyAddrid] === 3)?[_vm._v(" 計費重量小於等於0.05kg的輕小件全部不計重，每筆訂單最多可以贈送3個免重包裹位置。"),_c('br'),_c('br')]:[_vm._v(" 計費重量小於等於0.05kg的輕小件全部不計重"),_c('br'),_c('br')],_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 免重包裹說明："),_c('br'),_vm._v(" 如果訂單只有免重包裹（結帳時等於0KG），只需要支付島內派件費（暫不支持離島），就可以直接0KG打包回台。 ")])
}]

export { render, staticRenderFns }